import { render } from "./PaypalPaymentModal.vue?vue&type=template&id=7cbf5e7d&ts=true"
import script from "./PaypalPaymentModal.vue?vue&type=script&lang=ts"
export * from "./PaypalPaymentModal.vue?vue&type=script&lang=ts"

import exportComponent from "G:\\wamp\\www\\vahanwale\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__